import { render, staticRenderFns } from "./DropdownModal.vue?vue&type=template&id=089bf7a6&"
import script from "./DropdownModal.vue?vue&type=script&lang=js&"
export * from "./DropdownModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports